<template>
    <div v-if="values.length>0" :class="class_" :style="advanced?'':'display:block'">
        <div :class="title_class">{{ $t("message.Color") }}</div>
        <div class="color-schema">
            <span v-for="val in values" >
                <input type="checkbox" :id="'c_'+val.value" hidden v-model="color[val.value]" @change="change_val(val)">
                <label class="color-x" :style="{ 'background-color': '#'+val.value }" :for="'c_'+val.value" />
            </span>
        </div>
    </div>
</template>


<script>
  import FilterColorMix from "./FilterColorMix";

  export default {
    name      : 'filter-color',
    props:{
      is_show: { type: Boolean, default: true },
      title_class: {type: String, default:'works-filter__block-title'},
    },
    mixins: [FilterColorMix],
  }
</script>



// WEBPACK FOOTER //
// src/components/list/filter/FilterColor.vue